import React from 'react';
import { Toast } from 'primereact/toast';
import { SetRef } from './special/error-view';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import FudUsdtExchange from './FudUsdtExchange';

export default function App() {
  return (
    <>
      <Toast ref={SetRef} />
      <FudUsdtExchange />
    </>
  );
}

window.history.pushState(null,'','/usdt_exchange/');
